<script>
  /**
   * Set if dialog is showing
   * @type {boolean}
   */
  export let showing = false;

  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';
  import { db } from '../config/firebase';

  const dispatch = createEventDispatcher();

  let status = {
    initial: true,
    loading: false,
    success: false,
    error: false,
  };

  let data = {
    email: '',
    receiveUpdates: false
  };

  let firestore;

  function close() {
    showing = false;
    dispatch('closed');
  }

  function closeOnEscape(event) {
    if (event.key === 'Escape') {
      close();
    }
  }

  async function submit() {
    status.initial = false;
    status.loading = true;
    data.email = data.email
      .toLowerCase()
      .trim();

    try {
      await db.collection('applications').doc(data.email).set({
        createOn: Date.now(),
        receiveUpdates: data.receiveUpdates
      });
      status.success = true;
    } catch (e) {
      console.error(e);
      status.error = true;
    }

    status.loading = false;
  }

  function tryAgain() {
    status.initial = true;
    status.error = false;
  }

  $: if (showing) {
    try {
      document.body.classList.add('scroll-disabled');
    } catch (e) {
    }
  } else {
    try {
      document.body.classList.remove('scroll-disabled');
    } catch (e) {
    }
  }
</script>

<svelte:window on:keydown={closeOnEscape}/>

{#if showing}
  <article transition:fade="{{ duration: 200 }}">
    {#if status.initial}
      <form on:submit|preventDefault={submit}>
        <label class="email">
          <span class="email-text">Enter your email address to sign up for free and get notified when MenoAge gets launched:</span>
          <input class="email-input" type="email" bind:value={data.email}
            placeholder="e.g. jane.doe@email.com">
        </label>
        <label class="checkbox">
          <input class="checkbox-input" type="checkbox" bind:checked={data.receiveUpdates}>
          <span class="checkbox-text">Receive informative updates about MenoAge as well</span>
        </label>
        <div>
          <button class="neutral" type="button" on:click={close}>Cancel</button>
          <button class="positive" type="submit" on:click={submit}>Submit</button>
        </div>
      </form>
    {/if}
    {#if status.loading}
      <span class="loading"></span>
    {/if}
    {#if status.success}
      <p>Thank you for signing up and showing interest! We are very much looking forward to launching our product - our goal is to empower women to live healthier lives, for longer.</p>
      <button class="positive" on:click={close}>Back to website</button>
    {/if}
    {#if status.error}
      <p>There was an error in processing your sign up.</p>
      <div>
        <button class="neutral" on:click={close}>Close</button>
        <button class="positive" on:click={tryAgain}>Try again</button>
      </div>
    {/if}
  </article>
{/if}

<style>
  article {
    position: fixed;
    z-index: 9;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 2rem;
    background: var(--bg-1);
  }

  .email-text {
    display: block;
    max-width: 42ch;
    margin: auto;
    font-size: 1.25rem;
  }

  .email-input {
    display: block;
    margin: 1rem auto 3rem;
    font-family: var(--ff-2);
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 100%;
    border-bottom: .1rem solid;
    color: var(--fg-1);
    font-size: min(3rem, calc(18px + 2vw));
    text-align: center;
    padding: .5rem 0;
  }

  .checkbox {
    display: flex;
    align-items: center;
    text-align: left;
  }

  .checkbox-text {
    font-size: 1.125rem;
  }

  .checkbox-input {
    margin-right: .5rem;
    width: 1.5rem;
    height: 1.5rem;
  }

  div {
    margin: 2rem auto;
  }

  button {
    border: none;
    border-radius: .5rem;
    padding: 1rem 2rem;
    font-weight: bold;
    font-size: 1.5rem;
    font-family: var(--ff-1);
    cursor: pointer;
    transition: .2s;
    margin: 0 .25rem;
  }

  button:is(:hover,:focus) {
    box-shadow: .25rem .25rem 1px var(--fg-1);
  }

  .neutral {
    background: var(--a1-c);
    color: var(--a1-b);
  }

  .positive {
    background: var(--a1-b);
    color: var(--a1-c);
  }

  p {
    font-size: 1.5rem;
    max-width: 44ch;
  }

  .loading {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    border-top: .1rem solid var(--fg-1);
    border-bottom: .1rem solid var(--fg-1);
    border-right: .1rem solid transparent;
    border-left: .1rem solid transparent;
    animation: .7s loading linear infinite;;
  }

  @keyframes loading {
    to {
      transform: rotate(360deg);
    }
  }
</style>
